import { Button, FormControl, InputLabel, MenuItem, Select, TextField, Checkbox } from "@mui/material";
import styles from "./list.module.css";
import axios from "axios";
import { forwardRef, useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { authData } from "../../components/GetAuth";

const CustomInput = forwardRef((props, ref) => (<TextField {...props} inputRef={ref} id="outlined-basic" label="Amount(&pound;)*" variant="outlined" />));

const AddProductForm = ({ setFormOpen, setAllData, setSnackbarOpen, setSnackbarMessage, setSnackbarType, setLoading, editData }) => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [parentList, setParentList] = useState([]);
  const { register, handleSubmit, control, setValue, formState: { errors } } = useForm({
    mode: "onChange",
    defaultValues: {
      title: "",
      parent_id: "",
      amount: "",
      is_fragile: false,
    },
  });

  useEffect(() => {
    const fetchCategory = () => {
      axios.get(process.env.REACT_APP_API_URL + "v1/category-list", {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        let itemData = response.data.data;
        itemData = [{ value: 0, label: "No Category" }].concat(itemData);
        setParentList(itemData);
      }).catch((error) => { });
    };

    fetchCategory();
  }, [API_TOKEN]);

  useEffect(() => {
    if (editData) {
      setValue("title", editData?.title);
      setValue("amount", editData?.amount);
      setValue("parent_id", editData?.parent_id);
      setValue("is_fragile", editData?.is_fragile === 1 ? true : false);
    }
  }, [editData, setValue]);

  const onSubmit = (data) => {
    setLoading(true);
    setFormOpen(false);
    if (data.is_fragile) {
      data.is_fragile = 1;
    }
    if (editData) {
      axios.post(process.env.REACT_APP_API_URL + "v1/products/" + editData?.id, data, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          setAllData((prev) => {
            let temp = prev.map((i) => {
              if (i.id === editData?.id) {
                return response.data.data;
              }
              return i;
            });
            return temp;
          });
        }
        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    } else {
      axios.post(process.env.REACT_APP_API_URL + "v1/products", data, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          setAllData((prev) => {
            return [response.data.data].concat(prev);
          });
        }
        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    }
  };

  return (<form onSubmit={handleSubmit(onSubmit)}>
    <div className={`${styles.FormMainRow}`}>
      <div className={`${styles.FormGroupFull} FormGroup`}>
        <Controller
          control={control}
          {...register("title", { required: "This field is Required" })}
          render={({ field }) => (<TextField {...field} label="Title*" variant="outlined" />)}
        />
        {errors.title && (<span className={`ErrorM`}>{errors?.title?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupFull} FormGroup`}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Category*</InputLabel>
          <Controller
            control={control}
            {...register("parent_id", { required: "This field is Required" })}
            render={({ field }) => (
              <Select {...field} label="Category?*">
                {parentList?.map((val) => {
                  return (<MenuItem key={val?.value} value={val?.value}>
                    {val?.label}
                  </MenuItem>);
                })}
              </Select>
            )}
          />
        </FormControl>
      </div>
      <div className={`${styles.FormGroupFull} FormGroup`}>
        <Controller
          control={control}
          {...register("amount", { required: "This field is Required" })}
          render={({ field }) => (<NumericFormat {...field} customInput={CustomInput} decimalScale={2} />)}
        />

        {errors.amount && (<span className={`ErrorM`}>{errors?.amount?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupCheckBox} FormGroup`}>
        <FormControl fullWidth>
          <Controller
            name="is_fragile"
            control={control}
            render={({ field }) => (<Checkbox onChange={(e) => field.onChange(e.target.checked)} checked={field.value} />)}
          />
        </FormControl>
        <label className={`${styles.CheckBoxLabel}`}>Is fragile*</label>
      </div>
    </div>
    <div className="ButtonAction">
      <Button className="CancelPopupBU" onClick={(e) => setFormOpen(false)}>Cancel</Button>
      <Button className="SubmitPopupBU" type="submit">{editData ? "Update" : "Add"}</Button>
    </div>
  </form>);
};

export default AddProductForm;